module.exports = __webpack_public_path__ + "img/cover-slot-bg.a6742411.jpg";